module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "推广概览",
      "tip": "推广概览为您分产品线展示推广及效果数据，让您直观得看到各产品线的表现情况，进而优化各产品线推广策略。"
    }
  }, [(_vm.dianjingIDList.length > 0) ? _c('span', {
    staticClass: "floatr"
  }, [_c('label', [_vm._v("账号切换：")]), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dianjingID),
      expression: "dianjingID"
    }],
    attrs: {
      "options": _vm.dianjingIDList
    },
    domProps: {
      "value": (_vm.dianjingID)
    },
    on: {
      "input": [function($event) {
        _vm.dianjingID = $event
      }, function($event) {
        _vm.getTableData()
      }]
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "time"
  }, [_c('TimeSpan', {
    attrs: {
      "filters": "7a"
    },
    on: {
      "change": _vm.onTimespanChange
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }, [_c('div', {
    staticClass: "multiIndicesMenu"
  }, [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customIndice),
      expression: "customIndice"
    }],
    attrs: {
      "options": _vm.indicesMenu
    },
    domProps: {
      "value": (_vm.customIndice)
    },
    on: {
      "input": [function($event) {
        _vm.customIndice = $event
      }, _vm.indiceChange]
    }
  })], 1)]), _c('LineChart', {
    attrs: {
      "yAxis": _vm.yAxis,
      "legend": _vm.legend,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": "推广概览报表"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mvDemain),
      expression: "mvDemain"
    }],
    staticClass: "mv-tips"
  }, [_vm._v("为什么看不到流量及转化数据"), _c('v-tooltip', {
    attrs: {
      "tip": '由于您网站添加的代码为聚合分析代码，无法获取搜索推广对应的流量数据，若您想查看该部分数据，建议为您的网站重新添加360分析代码。',
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices,
      "hasSystemIndice": true,
      "hasSpreadIndice": true,
      "fluxExtend": _vm.fluxExtend
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('complex-table', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.list,
      "sum": {}
    }
  }), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pg,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getTableData
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4323783a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4323783a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/overall.vue
// module id = 745
// module chunks = 0